<template>
  <div
    class="template-padding"
    v-if="ongoingTrainings"
  >
    <h4 class="font-weight-bolder">
      Scheduled Training Course This Week
    </h4>
    <ul
      class="nav nav-tabs"
      id="list-tab"
      role="tablist"
    >
      <li class="nav-item">
        <a
          class="nav-link font-weight-bold active"
          id="list-overview"
          href="#overview"
          data-toggle="list"
        >Overview</a>
      </li>
      <li
        class="nav-item"
        v-for="(provider, index) in ongoingTrainings"
        :key="provider.id"
      >
        <a
          data-toggle="list"
          class="nav-link font-weight-bold"
          id="list-provider"
          href="#provider"
          @click="switchProviderIndex(index)"
        >
          {{ provider.code }}
        </a>
      </li>
    </ul>

    <div
      class="tab-content"
      id="nav-tabContent"
    >
      <div
        class="tab-pane fade show active"
        id="overview"
        role="tabpanel"
        aria-labelledby="list-overview"
      >
        <table class="table table-hover table-bordered">
          <thead class="table-header">
            <tr>
              <th class="col-index">
                #
              </th>
              <th>Crew Name</th>
              <th>Rank</th>
              <th>Date From</th>
              <th>Date To</th>
              <th>Training Course</th>
              <th class="col-header-month">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(crewTraining, index) in crewOngoingTrainings"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ crewTraining.crewName }}</td>
              <td>{{ crewTraining.rank }}</td>
              <td>{{ crewTraining.dateFrom | moment('DD MMM YYYY') }}</td>
              <td>{{ crewTraining.dateTo | moment('DD MMM YYYY') }}</td>
              <td>{{ crewTraining.trainingCourse }}</td>
              <td class="text-center ">
                <button
                  class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
                  title="VIEW SCHEDULE"
                  @click="$router.push(`/trainingSchedule/${crewTraining.scheduleId}`)"
                >
                  <span><i class="fas fa-eye" /></span>
                  VIEW
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="tab-pane fade"
        id="provider"
        role="tabpanel"
        aria-labelledby="list-provider"
      >
        <table class="table table-hover table-bordered">
          <thead class="table-header">
            <tr>
              <th class="col-index">
                #
              </th>
              <th>Training Course</th>
              <th>Date</th>
              <th class="col-header-month">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(trainingCourse, index) in providerSchedules"
              :key="index"
            >
              <td class="">
                {{ index + 1 }}
              </td>
              <td class="">
                <div class="match-content">
                  <span
                    class="float-right jewel-exp exp-2"
                    :title="`${trainingCourse.count} SCHEDULED CREWS`"
                  >{{ trainingCourse.count }}</span>
                  {{ trainingCourse.name }}
                </div>
              </td>
              <td v-if="trainingCourse.dateFrom === trainingCourse.dateTo">
                {{ trainingCourse.dateFrom | moment('DD MMM YYYY') }}
              </td>
              <td v-else>
                {{ trainingCourse.dateFrom | moment('DD MMM YYYY') }} - {{ trainingCourse.dateTo | moment('DD MMM YYYY') }}
              </td>
              <td class="text-center ">
                <button
                  class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
                  title="VIEW SCHEDULE"
                  @click="$router.push(`/trainingSchedule/${trainingCourse.scheduleId}`)"
                >
                  <span><i class="fas fa-eye" /></span>
                  VIEW
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "../../mixins/formMixins";
    export default {
        mixins: [formMixins],
        data() {
            return {
                index: 0
            }
        },
        name: 'Dashboard',
        methods: {
            ...mapActions([ 'getOngoingTrainings', 'getCrewOngoingTrainings' ]),
            switchProviderIndex(index) {
                this.index = index;
            }
        },
        computed: {
            ...mapGetters([ 'ongoingTrainings', 'crewOngoingTrainings' ]),
            providerSchedules() {
                if(this.ongoingTrainings.length) {
                    let provider = this.ongoingTrainings[this.index];
                    let schedules = [];

                    provider.trainingCourses
                        .forEach(course => {
                        course.schedules.forEach(schedule => {
                            let sched = {};
                            sched['name'] = course.name;
                            sched['count'] = schedule.count;
                            sched['dateFrom'] = schedule.dateFrom;
                            sched['dateTo'] = schedule.dateTo;
                            sched['scheduleId'] = schedule.trainingScheduleId;
                            schedules.push(sched);
                        });
                    });

                    schedules.sort( (schedule, nextSchedule) =>
                        (schedule.dateFrom > nextSchedule.dateFrom) ? 1 : (nextSchedule.dateFrom < schedule.dateFrom ? -1 : 0)
                    )

                    return schedules;
                } else {
                    return null;
                }
            }
        },
        async created() {
            this.getCrewOngoingTrainings();
            this.getOngoingTrainings();
        }
    };
</script>

<style scoped>

</style>
